import { InvoiceTotals } from '@models';
import { Invoice, InvoicePayment } from '@services';
import { Utils } from '@utils';
import { useMemo } from 'react';

export const useInvoiceTotals = (
  invoice?: Invoice,
  payments?: InvoicePayment[]
): InvoiceTotals | null => {
  return useMemo(() => {
    if (!invoice) return null;

    const basePrice = invoice.amount || 0;
    const vat = invoice.vat || 0;
    const invoiceSubtotal = basePrice;
    const invoiceVat = vat;
    const invoiceTotal = Utils.roundToTwoDecimals(basePrice + vat) || 0;
    const creditTotal = Utils.calculateCreditTotal(payments ?? []) || 0;
    const refundPaidTotal = Utils.calculateRefundPaidTotal(payments ?? []) || 0;
    const refundRequestedTotal = Utils.calculateRefundRequestedTotal(payments ?? []) || 0;
    const refundTotal = Utils.roundToTwoDecimals(refundPaidTotal - refundRequestedTotal) || 0;
    const paymentTotal = Utils.calculatePaymentTotal(payments ?? []) || 0;
    // Final invoice amount after credits and refunds
    // invoice subtotal = 1000
    // invoice vat = 200
    // total amount = 1000 + 200 = 1200
    // payment total = 500
    // full refund = 1200 credit
    // total invoice amount = - 500
    // total refund = 500
    // align this and you will get total invoice = 0 - which is paid/refunded whatever, so we can close it

    const dueTotal = Utils.roundToTwoDecimals(invoiceTotal - creditTotal - paymentTotal + refundTotal);
    //const dueTotal = invoiceTotal - creditTotal - paymentTotal - refundPaidTotal;

    return {
      invoiceTotal,
      creditTotal,
      refundTotal,
      refundPaidTotal,
      refundRequestedTotal,
      paymentTotal,
      dueTotal,
      invoiceSubtotal,
      invoiceVat,
    };
  }, [invoice, payments]);
};
